/* global I18n */

import introJs from "intro.js"
import "intro.js/introjs.css"
import ajax from "ajax"
import viewport_helper from "./viewport_helper"

function study_unit_tour(controller) {
  const intro = introJs()
  intro.setOptions({
    steps: [
      {
        element: ".highlighted-box",
        title: I18n.t("js.tours.study_unit.tour"),
        intro: `<b>${I18n.t("js.tours.study_unit.title_1")}</b>
          ${I18n.t("js.tours.study_unit.description_1")}`,
        position: "top",
        tooltipClass: "tooltip-step-1"
      },
      {
        element: ".embedded-video-container",
        title: I18n.t("js.tours.study_unit.tour"),
        intro: `<b>${I18n.t("js.tours.study_unit.title_2")}</b>
          ${I18n.t("js.tours.study_unit.description_2")}`,
        position: "top",
        tooltipClass: "tooltip-step-2"
      },
      {
        element: ".embedded-quiz-container",
        title: I18n.t("js.tours.study_unit.tour"),
        intro: `<b>${I18n.t("js.tours.study_unit.title_3")}</b>
          ${I18n.t("js.tours.study_unit.description_3")}`,
        position: "top",
        tooltipClass: "tooltip-step-3"
      },
      {
        element: ".overview-images-container, .image-gallery-container",
        title: I18n.t("js.tours.study_unit.tour"),
        intro: `<b>${I18n.t("js.tours.study_unit.title_4")}</b>
          ${I18n.t("js.tours.study_unit.description_4")}`,
        position: "top",
        tooltipClass: "tooltip-step-4"
      },
      {
        element: ".complete-su-box-wrapper",
        title: I18n.t("js.tours.study_unit.tour"),
        intro: `<b>${I18n.t("js.tours.study_unit.title_5")}</b>
          ${I18n.t("js.tours.study_unit.description_5")}`,
        position: "top",
        tooltipClass: "tooltip-step-5"
      }
    ],
    showStepNumbers: true,
    stepNumbersOfLabel: "/",
    nextLabel: I18n.t("js.tours.next"),
    prevLabel: I18n.t("js.tours.back"),
    doneLabel: I18n.t("js.tours.done"),
    showBullets: false,
    scrollToElement: false,
    positionPrecedence: ["top", "bottom"]
  }).onstart(() => {
    document.body.classList.add("tour-running")
  }).onbeforechange(targetElement => {
    viewport_helper.go_to(targetElement, {margin: 220, behavior: "smooth"})
  }).onafterchange(() => {
    move_step_number_to_footer()
    setTimeout(() => intro.refresh(), 1000)
  }).oncomplete(on_close_tour)
    .onexit(on_close_tour)
    .start()

  // makes sure that the tour and is background layer gets repositioned when
  // the page height changes
  controller.tour_observer = new ResizeObserver(() => {
    const height = document.documentElement.scrollHeight
    const box_shadow = `rgba(33, 33, 33, 0.5) 0px 0px 0px ${height}px`
    const layer = document.querySelector(".introjs-helperLayer")
    if (!layer) return

    layer.style.boxShadow = box_shadow
    intro.refresh()
  })
  controller.tour_observer.observe(document.documentElement)
}

function on_close_tour() {
  document.body.classList.remove("tour-running")
  ajax.post(window.gon.api_user_completed_tours_path, {tour: "study_unit_tour"})
}

function move_step_number_to_footer() {
  const step_number_el = document.querySelector(".introjs-helperNumberLayer")
  const buttons_container = document.querySelector(".introjs-tooltipbuttons")
  if (!step_number_el || !buttons_container) return

  buttons_container.appendChild(step_number_el)
}

export default study_unit_tour
